import { useState, useEffect, useCallback } from "react";
import { adminApi, AdminOrg } from "../../../../services/api/admin";
import { parseApiError } from "../../../../services/api/errorPresentation";
import { useLoadState } from "../../../../hooks/useLoadState";

interface UseAdminOrgsReturn {
  orgs: AdminOrg[];
  loading: boolean;
  error: string | null;
  reload: () => void;
}

export const useAdminOrgs = (): UseAdminOrgsReturn => {
  const [orgs, setOrgs] = useState<AdminOrg[]>([]);
  const [error, setError] = useState<string | null>(null);
  // `reload` läuft nach dem Anlegen eines Mandanten – dann bleibt die Liste stehen, statt die
  // Seite gegen den Spinner zu tauschen.
  const { loading, ladenStarten, ladenBeenden } = useLoadState();

  const load = useCallback(async () => {
    ladenStarten();
    setError(null);
    try {
      const data = await adminApi.getOrganisations();
      setOrgs(data);
    } catch (err) {
      setError(parseApiError(err).message);
    } finally {
      ladenBeenden();
    }
  }, [ladenStarten, ladenBeenden]);

  useEffect(() => {
    load();
  }, [load]);

  return { orgs, loading, error, reload: load };
};
